module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1078.e6f5ea3d.png";